(function($) {
	const pwChangeForm        = '.pw-change-form';

	let $pwChangeForm       = $(pwChangeForm);
	let $pwInput            = $(`${pwChangeForm} [name="password"]`);
	let $pwConfirmInput     = $(`${pwChangeForm} [name="password_confirm"]`);
	
	$(document).ready(function() {
		if( $pwChangeForm.length === 0 ) return;
		
		console.log('hello');
	});
	
})(jQuery)